import React from 'react';
import T from 'prop-types';

import Icon from '@ably/ui/core/Icon';

export default function Dropdown(props) {
  const { collection, current, update } = props;

  if (!collection) return null;

  const language = current ? current.lang : '';
  const key = `${language}${performance.now()}`;
  const selected = collection.findIndex(({ lang }) => lang === language) + 1;

  const options = [
    ...(selected === 0
      ? [
          <option key={''} value={''} data-selected={false}>
            Other
          </option>,
        ]
      : []),
    collection.map((el) => {
      const { lang, name } = el;
      return (
        <option key={lang} value={lang} data-selected={el.lang === language}>
          {name}
        </option>
      );
    }),
  ];

  const handleOnChange = (e) => {
    const { value } = e.target;
    if (value === '') return;
    e.target.dataset.id = value;
    update(e);
  };

  const classname = `ui-code-explorer-select appearance-none ${selected && 'selected'}`;

  return (
    <div>
      <select key={key} onChange={handleOnChange} defaultValue={language} className={classname}>
        {options}
      </select>
      <Icon
        name="icon-gui-chevron-down-micro"
        size="1.5rem"
        color="text-white"
        additionalCSS="mr-8 absolute right-0 top-4 pointer-events-none"
      />
    </div>
  );
}

Dropdown.propTypes = {
  collection: T.array,
  update: T.func,
  current: T.object,
};
